import { appStore } from '../../app/AppStore';
import { AppState } from '../../app/state/AppState';

/**
 * Placeholder function to use selectors without a direct dependency on redux store. This is implemented
 * in later versions of react redux
 * @param selector
 */
export function useSelector<T>(selector: (state: AppState) => T): T {
  return selector(appStore.getState());
}
